export const environment = {
    production: true,
    auth_server: {
        base_url: "https://auth.dev-ctalk.xyz",
    },
    homeserver: "https://matrix.dev-ctalk.xyz",
    enableVConsole: false,
};
